import type { ReactNode } from 'react';
import { cn } from '../../../utils/cn';
import styles from './Card.module.css';

export interface CardProps {
  title?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  /** When true, removes body padding — caller controls the layout (e.g. tables). */
  flush?: boolean;
  className?: string;
}

export function Card({ title, actions, children, flush = false, className }: CardProps) {
  const hasHeader = title !== undefined || actions !== undefined;
  return (
    <section className={cn(styles.card, className)}>
      {hasHeader ? (
        <header className={styles.header}>
          {title !== undefined ? (
            typeof title === 'string' ? (
              <h2 className={styles.title}>{title}</h2>
            ) : (
              <div className={styles.title}>{title}</div>
            )
          ) : (
            <span />
          )}
          {actions !== undefined ? <div className={styles.actions}>{actions}</div> : null}
        </header>
      ) : null}
      <div className={cn(styles.body, flush && styles.bodyFlush)}>{children}</div>
    </section>
  );
}
